import { useMemo } from "react";
import { SolicitorNotificationTagEnum } from "../../../../models/enum/solicitor-notification-tag.enum";
import "./search-info.scss";

interface SearchInfoProps {
  numberOfResults: number;
  tag: SolicitorNotificationTagEnum | null;
  searchTerm: string;
}

export function SearchInfo({ numberOfResults, tag, searchTerm }: SearchInfoProps) {
  const filterTag = useMemo(() => {
    switch (tag) {
      case SolicitorNotificationTagEnum.new_update:
        return "New updates";
      case SolicitorNotificationTagEnum.action_required:
        return "Action required";
      default:
        return "All cases";
    }
  }, [tag]);

  if (numberOfResults === 0) {
    return (
      <p className="polymer-search-info">
        There is <span className="polymer-search-info__highlight">0</span> result for <span className="polymer-search-info__highlight">"{searchTerm}"</span>
      </p>
    );
  }

  if (numberOfResults === 1) {
    return (
      <p className="polymer-search-info">
        There is <span className="polymer-search-info__highlight">{numberOfResults}</span> result for{" "}
        <span className="polymer-search-info__highlight">"{searchTerm}"</span>
      </p>
    );
  }

  return (
    <p className="polymer-search-info">
      There are <span className="polymer-search-info__highlight">{numberOfResults}</span> results for{" "}
      <span className="polymer-search-info__highlight">"{searchTerm}"</span>
    </p>
  );
}
